import { useMemo } from "react";
import { useParams } from "react-router-dom";
import DonutChart from "src/components/ScoringChart/DonutChart";
import VectorMetric from "src/components/utils/VectorMetric";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useAnalysisSelector } from "src/context/analysisContext";

const getOption = () => ({
  chart: {
    height: 180,
  },
  legend: {
    align: "left",
    verticalAlign: "middle",
    layout: "vertical",
    useHTML: true,
    labelFormatter: function () {
      return `<div style='width:150px;display:flex;justify-content:space-between;margin-bottom:5px'><div>${this.name}</div><div>${this.y}%</div></div>`;
    },
  },
});

export default function CreditScoreDistribution() {
  const { holder } = useParams();
  const rangeScore = useAnalysisSelector((state) => state.statistic[holder]?.rangeScore);

  const realRange = useMemo(() => {
    if (rangeScore?.ranges) {
      const ranges = rangeScore?.ranges;
      const level1 = ranges["Warrior"][1] - ranges["Warrior"][0];
      const level2 = ranges["Conqueror"][1] - ranges["Conqueror"][0];
      const level3 = ranges["Hero"][1] - ranges["Hero"][0];
      const level4 = ranges["Master"][1] - ranges["Master"][0];
      const level5 = ranges["Legendary"][1] - ranges["Legendary"][0];
      return [level1, level2, level3, level4, level5];
    }
    return [0, 0, 0, 0, 0];
  }, [rangeScore, holder]);

  const percentages = useMemo(() => {
    if (rangeScore?.percentages) {
      const data = Object.keys(rangeScore.percentages).map((element) => {
        return {
          name: element,
          y: rangeScore.percentages[element],
        };
      });
      return [
        {
          name: undefined,
          data: data,
        },
      ];
    }
    return [
      {
        name: undefined,
        data: [],
      },
    ];
  }, [rangeScore, holder]);

  return (
    <PaperWrapper
      title="Credit Score Distribution"
      style={{ marginTop: "1.5rem" }}
      paperProps={{ style: { height: 265 } }}
    >
      <DonutChart series={percentages} option={getOption()} />
      <VectorMetric
        ranges={realRange}
        categories={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
        style={{ paddingTop: "0.5rem" }}
      />
    </PaperWrapper>
  );
}
